<div class="skeletor-table">
  <div class="skeletor-table-header">
    <p-skeleton width="6rem" class="mr-4" />
    <p-skeleton width="10rem" class="mr-4" />
    <p-skeleton width="8rem" class="mr-4" />
    <p-skeleton width="12rem" class="mr-4" />
    <p-skeleton width="6rem" class="mr-4" />
    <p-skeleton width="8rem" class="mr-4" />
    <p-skeleton width="10rem" />
  </div>
  <div class="skeletor-table-body">
    <div *ngFor="let i of rows" class="skeletor-table-row">
      <p-skeleton width="6rem" class="mr-4" />
      <p-skeleton width="10rem" class="mr-4" />
      <p-skeleton width="8rem" class="mr-4" />
      <p-skeleton width="12rem" class="mr-4" />
      <p-skeleton width="6rem" class="mr-4" />
      <p-skeleton width="8rem" class="mr-4" />
      <p-skeleton width="10rem" />
    </div>
  </div>
</div>

